import * as React from 'react';
import { useSolutions, useRowHeights, useUnassignedTasksBySolution } from '../../state/context';
import Group from './Group';

const SolutionsTasks = () => {
  const solutions = useSolutions();
  const rowHeights = useRowHeights();
  const tasks = useUnassignedTasksBySolution();
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        ref.current.style.transform = `translateY(-${window.scrollY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div ref={ref}>
      {solutions.map((solution) => (
        <Group
          key={solution.id}
          height={rowHeights[solution.id]}
          tasks={tasks[solution.id] || []}
        />
      ))}
    </div>
  );
};

export default SolutionsTasks;
